// Servicio del módulo Gestión institucional. Usa la instancia común de axios
// (token + CSRF), pero /me/ resuelve 401/403/404 sin pasar por el catch para
// que el menú pueda esconderse sin dejar errores de JS en la consola.
import api from "@/services/api";

const QUIET = { validateStatus: (s) => [200, 401, 403, 404].includes(s) };

export default {
  me() {
    return api.get("institucional/me/", QUIET);
  },
  get(path, params) {
    return api.get(`institucional/${path}`, { params }).then((r) => r.data);
  },
  download(path, filename) {
    return api
      .get(`institucional/${path}`, { responseType: "blob" })
      .then((r) => {
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      });
  },
  putParams(networkId, schoolId, data) {
    return api
      .put(`institucional/networks/${networkId}/params/${schoolId}/`, data)
      .then((r) => r.data);
  },
};
